import sinoTable from "./table/sinoTable";
import sinoButton from "./button/sinoButton";
import tooltipButton from "./button/tooltipButton";
import sinoSelect from "./form/sinoSelect";
import sinoTransfer from "./transfer/sinoTransfer"
import sinoTabs from "./tabs/sinoTabs"
import lineTabs from "./tabs/lineTabs"
const SinoEleUI = {};
SinoEleUI.components = [
    sinoTable,
    sinoButton,
    tooltipButton,
    sinoSelect,
    sinoTransfer,
    sinoTabs,
    lineTabs,
];

SinoEleUI.install = function (Vue) {
    this.components.map((r) => Vue.component(r.name, r));
};
export default SinoEleUI;
